import { Component, DestroyRef, Input } from '@angular/core';
import { CallLogListComponent } from '../call-log-list/call-log-list.component';
import { CallLogViewComponent } from '../call-log-view/call-log-view.component';
import { CallLogResponse } from '../../../models/responses/call-log-response';
import { CallLogService } from '../../../services/call-log.service';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { NgIf } from '@angular/common';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { SubscriptionHelper } from '../../../classes/subscription-helper';

@Component({
  selector: 'app-call-log-tab',
  standalone: true,
  imports: [
    CallLogListComponent,
    CallLogViewComponent,
    NgIf
  ],
  templateUrl: './call-log-tab.component.html',
  styleUrl: './call-log-tab.component.scss'
})
export class CallLogTabComponent {
  @Input() aiAgent!: AiAgentResponse;
  callLogResponses!: CallLogResponse[];
  currentCallLog: CallLogResponse | undefined;
  shouldRenderCallViewComponent: boolean = false;
  subscriptions: SubscriptionHelper;

  constructor(
    private callLogService: CallLogService,
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
    private destroyRef: DestroyRef
  ) { 
    this.subscriptions = new SubscriptionHelper(destroyRef);
  }

  ngOnInit(){
    this.initCallLogs();
    this.initSubscriptions();
  }

  initSubscriptions(){
    this.subscribeToOnCallLogViewEvent();
    this.subscribeToOnCallLogViewBackEvent();
    this.subscribeToOnCallLogViewDeletedEvent();
  }

  subscribeToOnCallLogViewDeletedEvent(){
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onCallLogViewDeletedEvent.subscribe(() => {
        this.initCallLogs();
      })
    );
  }

  subscribeToOnCallLogViewBackEvent(){
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onCallLogViewBackedClickedEvent.subscribe(() => {
        this.currentCallLog = undefined;
        this.shouldRenderCallViewComponent = false;
      })
    );
  }

  subscribeToOnCallLogViewEvent(){
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onCallLogViewClickedEvent.subscribe(callLog => {
        this.currentCallLog = callLog;
        this.shouldRenderCallViewComponent = true;
      })
    );
  }

  initCallLogs() {
    this.callLogService.fetchAllByAiAgent(this.aiAgent.id).subscribe({
      next: (callLogs) => {
        this.callLogResponses = callLogs;
        this.currentCallLog = undefined;
        this.shouldRenderCallViewComponent = false;
      },
      error: () => {
        alert('Server error contact support');
      }
    })
  }
}
